import { render, staticRenderFns } from "./SidebarHeading.vue?vue&type=template&id=f379e624&scoped=true&"
import script from "./SidebarHeading.vue?vue&type=script&lang=ts&"
export * from "./SidebarHeading.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarHeading.vue?vue&type=style&index=0&id=f379e624&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f379e624",
  null
  
)

export default component.exports